import { render, staticRenderFns } from "./LeadAssignHistory.vue?vue&type=template&id=1ed9b014&scoped=true"
import script from "./LeadAssignHistory.vue?vue&type=script&lang=js"
export * from "./LeadAssignHistory.vue?vue&type=script&lang=js"
import style0 from "./LeadAssignHistory.vue?vue&type=style&index=0&id=1ed9b014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9b014",
  null
  
)

export default component.exports